module.exports = __webpack_public_path__ + "static/media/AU-BUV-2100041_Buvidal-Patient-educational-material.4fd8098b.pdf";